// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import constants from "@store/constants";
import setFieldValue from "@store/Framework/Store/Greif/Components/RecommendedProductRequestForm/Handlers/SetFieldValue";
import { RecommendedProductRequestFormContext } from "@store/Library/Widgets/RecommendedProductRequest/RecommendedProductRequestForm";
import React, { ChangeEvent, FC, useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    isDisabled = "isDisabled",
    isRequired = "isRequired",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.isDisabled]: boolean;
        [fields.isRequired]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    currentShipTo: getCurrentShipToState(state),
    customerNumber: state.greif.components.recommendedProductRequestForm.fieldValues["customerNumber"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CustomerNumberStyles {
    customerNumberTextField?: TextFieldPresentationProps;
}

export const customerNumberStyles: CustomerNumberStyles = {};

const styles = customerNumberStyles;

const CustomerNumber: FC<Props> = ({ fields, currentShipTo, customerNumber, setFieldValue }) => {
    const { isRequired, isDisabled } = fields;
    const recommendedProductRequestFormContext = useContext(RecommendedProductRequestFormContext);
    const [customerNumberErrorMessage, setCustomerNumberErrorMessage] = useState("");

    const customerNumberLabel = translate("Greif Ship to Customer Number");

    useEffect(() => {
        if (currentShipTo.value && !currentShipTo.isLoading) {
            setFieldValue({ key: "customerNumber", value: currentShipTo.value.customerNumber });
        }
    }, [currentShipTo]);

    useEffect(() => {
        recommendedProductRequestFormContext.validators.customerNumber = validateCustomerNumber;
        if (typeof customerNumber !== "undefined") {
            validateCustomerNumber();
        }
    }, [customerNumber]);

    useEffect(() => {
        recommendedProductRequestFormContext.validators.customerNumber = validateCustomerNumber;
    }, [isRequired]);

    const validateCustomerNumber = () => {
        const errorMessage =
            isRequired && !customerNumber ? siteMessage("Field_Required", customerNumberLabel).toString() : "";
        setCustomerNumberErrorMessage(errorMessage);
        return !errorMessage;
    };

    const customerNumberChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        setFieldValue({ key: "customerNumber", value: event.target.value });
    };

    return (
        <TextField
            {...styles.customerNumberTextField}
            label={customerNumberLabel}
            value={currentShipTo.value?.customerSequence || ""}
            onChange={customerNumberChangeHandler}
            required={isRequired}
            error={customerNumberErrorMessage}
            disabled={isDisabled}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CustomerNumber),
    definition: {
        displayName: "Customer Number",
        group: constants.widgetGroup.recommendedProductRequest,
        icon: "input-pipe",
        allowedContexts: [constants.pageType.recommendedProductRequest],
        fieldDefinitions: [
            {
                name: fields.isDisabled,
                displayName: "Disabled?",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
